import { useEffect } from 'react';
export default function useComponentDidUnmount(cb: () => void) {
	useEffect(() => cb, []);
}
